import {markRaw} from 'vue';
import {GraphQLClient, GraphQLClientPreloadDecorator, GraphQLClient401ReloadDecorator} from "@datapas/graphql-client";

const graphqlClient = new GraphQLClient401ReloadDecorator(new GraphQLClientPreloadDecorator(new GraphQLClient(GraphQLClient.DEFAULT_ENDPOINT, true)));

export class GraphqlPluginVue {
	static install(app) {
		app.config.globalProperties.$graphql = graphqlClient;
	}
}

export function GraphqlPluginPinia() {
	return {
		$graphql: markRaw(graphqlClient),
	}
}
